/**
 * PipelineActivityRow — one entry of the pipeline audit trail (SE-5504).
 * @module features/player-kanban/components/molecules/PipelineActivityRow
 */

export { default } from "./PipelineActivityRowView";
export type { PipelineActivityRowViewProps } from "./PipelineActivityRowView";
